import gql from 'graphql-tag';

import client from '../graphqlAPI';

const SEARCH_POSTS_QUERY = gql`
  query searchArtistSets($search: String!, $eventSlugName: String!) {
    searchArtistSets(search: $search, eventSlugName: $eventSlugName) {
      artistName
      artistSlugName
      artistSetSlugName
    }
  }
`;

const getSearchArtistSets = async (search, eventSlugName) => {
  try {
    const result = await client
      .query({
        query: SEARCH_POSTS_QUERY,
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        variables: { search, eventSlugName },
        fetchResults: true,
        pollInterva: 300000,
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });
    const {
      data: { searchArtistSets },
    } = result;

    if (searchArtistSets) {
      return searchArtistSets;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: searchArtistSets`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: searchArtistSets Error: ${error}`);
    return null;
  }
};

export default getSearchArtistSets;
